import { Route, Routes as RoutesContainer } from "react-router";
import { Login } from "../index";

const LoginRoutes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/' element={<Login />} />
    </RoutesContainer>
  );
};
export default LoginRoutes;
